
















































import { Component, Watch } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import LocationDto from '@/models/Locations/LocationDto';
import UpdateLocationPayrollSystemSettingsRequest from '@/models/Locations/UpdateLocationPayrollSystemSettingsRequest';

@Component({
    name: 'LocationExternalPayrollEdit'
})
export default class extends GiganautVueDialog {

  public entity: LocationDto | null = null;

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val) {
      // Deep-clone so the dialog edits don't mutate the live store row
      // before save (mirrors DeskExternalPayrollEdit).
      this.entity = JSON.parse(JSON.stringify(LocationDetailsModule.currentLocation));
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.entity) {
      return;
    }
    const request = new UpdateLocationPayrollSystemSettingsRequest();
    request.updatedAt = this.entity.updatedAt;
    request.externalPayrollSystemId = this.entity.externalPayrollSystemId || '';
    await LocationDetailsModule.editLocationPayrollSystemSettings(request);
    this.dialog = false;
  }
}
